import React from 'react';
import ImageCropper1 from '../../pages/helper/ImageCropper1';

const ImageCropper = () => {
  return (
    <ImageCropper1 />
  );
};

export default ImageCropper;  